<template>
  <div class="map_page">
    <!-- <head-top :head-title="title"></head-top> -->
    <div class="m-map">
      <div id="js-container" class="map"></div>
      <div class="address_info" id="addressInfo">
        <strong>{{ name }}</strong>
        <div>{{ address }}</div>
        <div class="btnGo" @click="showCustomPopupClick"></div>
      </div>
    </div>
    <popup ref="CustomPopupRef">
      <div slot="PoperContent" class="PoperContentView">
        <ul>
          <li v-for="(ele, index) in mapTypes" :key="index" class="bdb" @click="openMap(ele)">{{ ele.name }}</li>
        </ul>
        <div class="btn_cancel" @click="closeButton">取消</div>
      </div>
    </popup>
  </div>
</template>
<script>
import remoteLoad from "map/utils/remoteLoad.js";
import headTop from "map/head";
import popup from "map/popup";
import { GgpsToBgps } from "map/utils/util";
export default {
  data() {
    return {
      title: "位置信息",
      mapKey: "f50ba7028b228f86354bae875dd7f7ce",
      BKey: "TR9oRN8Z73rpnB7GhSRn9D1V51YPLVKm",//百度地图
      AMap: null,
      name: "",
      address: "",
      mapTypes: [
        {
          name: "腾讯地图",
          url: ""
        },
        {
          name: "百度地图",
          url: ""
        },
        {
          name: "高德地图",
          url: ""
        }
      ],
      longitude: "0",
      latitude: "0",
      originLongitude: "0",
      originLatitude: "0"
    };
  },
  created() {
    this.longitude = this.$route.query.longitude;
    this.latitude = this.$route.query.latitude;
    this.address = this.$route.query.address;
    this.originLongitude = this.$route.query.originLongitude;
    this.originLatitude = this.$route.query.originLatitude;
    this.name = this.$route.query.name;
    this.initMapType(this.longitude, this.latitude, this.address);

    remoteLoad(`https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${this.BKey}&callback=${this.initBMap()}`);
  },
  components: {
    headTop,
    popup
  },
  methods: {
    initBMap() {
      setTimeout(() => {
        let height =
          document.querySelector(".m-map").offsetHeight -
          document.getElementById("addressInfo").offsetHeight;
        document.getElementById("js-container").style.height = height + "px";
        let map = new BMapGL.Map("js-container");
        map.enableScrollWheelZoom(true);
        // 创建地图实例 
        var newGps = GgpsToBgps(parseFloat(this.longitude), parseFloat(this.latitude));
        var point = new BMapGL.Point(newGps.bd_lng, newGps.bd_lat);
        // 创建点坐标 
        map.centerAndZoom(point, 15);
        var scaleCtrl = new BMapGL.ScaleControl(); //添加比例尺控件
        map.addControl(scaleCtrl);
        var zoomCtrl = new BMapGL.ZoomControl(); //添加缩放控件
        map.addControl(zoomCtrl);
        var cityCtrl = new BMapGL.CityListControl(); //添加城市列表控件
        map.addControl(cityCtrl);

        var marker = new BMapGL.Marker(point); //创建标注   
        map.addOverlay(marker); //将标注添加到地图中
      }, 600);
    },
    showCustomPopupClick() {
      this.$refs.CustomPopupRef.showCustom();
    },
    closeButton() {
      this.$refs.CustomPopupRef.maskClick();
    },
    openMap(item) {
      location.href = item.url;
    },
    initMapType(lon, lat, address) {
      let mapTypes = this.mapTypes;
      for (let i = 0; i < mapTypes.length; i++) {
        switch (mapTypes[i].name) {
          case "高德地图":
            mapTypes[i].url = `https://uri.amap.com/marker?position=${lon},${lat}&name=${address}&content=&output=html`;
            // mapTypes[
            //   i
            // ].url = `iosamap://path?sid=&slat=${this.originLatitude}&slon=${this.originLongitude}&sname=&did=&dlat=${lat}&dlon=${lon}&dname=${address}&dev=0&t=0`;
            break;
          case "百度地图":
            var newGps = GgpsToBgps(parseFloat(this.longitude), parseFloat(this.latitude));
            mapTypes[
              i
            ].url = `https://api.map.baidu.com/marker?location=${newGps.bd_lat},${newGps.bd_lng}&title=${address}&content=&output=html`;
            break;
          case "腾讯地图":
            mapTypes[
              i
            ].url = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lon};title:${address};addr:""&referer=`;
            break;
          default:
            break;
        }
      }
      this.mapTypes = mapTypes;
    }
  }
};
</script>
<style>
.map_page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 0;
  background-color: #ffffff;
  z-index: 100;
  overflow: scroll;
  font-size: 14px;
}

.m-map {
  /* height: calc(100% - 36px);
  top: 36px; */
  height: 100%;
  top: 0;
  position: relative;
}

.m-map .map {
  width: 100% !important;
}

.address_info {
  background-color: #ffffff;
  padding: 14px;
  font-size: 12px;
  position: relative;
  padding-right: 80px;
}

.address_info strong {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.address_info div {
  color: #999999;
  padding-top: 6px;
}

.btnGo {
  display: block;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAk1BMVEUAAADmgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi3mgi1K3sRSAAAAMHRSTlMABAkM+qmk9urlLfGFS57tkBbd0a0S4Tsm2MCZxrGWikIhGmBagXxmNcu7dlW1bzLS0wsjAAAEI0lEQVRo3rWY2YKaQBBFbwGyKSIggriAgLuO/f9fl0yM0RCkCzDndQaP3VW3SgUPovBQjvQk8C3TtGZBMkiLyCPCpyDalOOjKf7BDfQiJvqEId4dh+ItRpDeFOqnCPcnQ0jQll85dVfEqSVYmAubOirWrmBj6Ddqr8i3pmiFkba9NLWci9ZY+xB8aDMWnVjxS6M4M9GRYaGChbcVPZjkYLCZil4kMUGGvRQ9mUcSCx180RvXabZEM/EBho2WA9vR3WL74kMMo7d9xai55mosi2+jlnDAeIfjcmGwLMu8Nuc7xhAcAcqad5ZFXfYdxl2Nvx/0dJ5lT/8WZCZ3TPP7v155s/+GCuqYMzDaTYVTdfJfhJTggAcZb9t8EV7x5E/5Dp5cTNZ8ifECyTvLvOCV/ZBjGSt4ErvSgHzhb3asuLwEn9aMgFSgCaeRr8qzfWVn16rJesaFfZRU5hh4daNuxZAMCHdCS9bwceclajweLUQzxwOq8OOyxS8okQQkwzscS77x76WPjeaAlKjQLi7ZveNbBaR1XMb4CR0bC7dFM9K4zBQAudHUvGuSSFRpXA6S+WvoIWTkU4llB1DTIrEuoBfwgFTlD9i7kpQRKGg6yXU7+kNaKrijFJMn6VJyEktB6Aouifqow1W0QItxE2xWfyQD0YYLSsFm2lGyxfb/SwbQW0iUbpIEp/8vCRD8f4kP/3MS7V1QYH1CYi1Xenrep2b9soDZV2Is9bNj599/e1Ngt6/EHxe2ggfTekmb6xpQVXLcZQpeWL25Lr+7ZH6+AZBLLARdJcN1BLAkPpKOkmWpgCkJMOgiWQndRg31M2qJUQeJpy881KCe6p9D0eUkt7D68lFxHk1WQ1HHCAe+RCfUojq7VdDwI0IJz+0pyffT5hhoNijoJVGKk+yTqqUCeh/JTZdfREJAwZegyuUo5IwAbIzOki+L++WUX5RxxXF+VkNSEtCoo2Q/ZH5W+cbWOkkc5iZy8A0tu0hs5lO++rt+XSQp8/wp7ngmW8L/SvqM+x1at5bQWPC40p/75UVl8ZRk3K2d4QHpbSXctk8U4HmUdpJwxZQ4eEJpO0k0Z645BS/kVivJnte/hl2ZEXwJvyRbwl+E0zYSXs8fPVSw5dtn3TIlEapQyZPwW/5M+Ad18lnJIEQN+emTkvkGtcSS7p/gwULqcA94Q+Q2d0sWet+ETiCPOuEdWeNG1czZHVOaxZLwFnKelj4UChqgzO2v0EoFjVA07+swHYIEipN+jvmBICdf93EMNmChFt3Lfw7BhOxrN8UxI/AJv8z2CmPrEdpAm7XW0qHbhLYo0bSN5uQo6IJy0JkdoK0yhdAR2uwCRjJSm9AHUrOF33Rtlu6ohN6QcjhfZzUibZZsI4aBL4qdnZ4c55ZlmqblB8lge7FV4hl+AO9j3aZ3w1csAAAAAElFTkSuQmCC) 0 0 no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  width: 45px;
  height: 45px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.PoperContentView {
  color: #000000;
  background-color: #f0f0f0;
  border-radius: 10px;
}

.PoperContentView ul {
  background-color: #ffffff;
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.PoperContentView ul li {
  height: 45px;
  line-height: 45px;
}

.btn_cancel {
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  text-align: center;
  color: #000000;
  margin-top: 5px;
}
</style>